import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { asve } from '../shared/orve';
import {
  getAssessmentContentPercentile,
  getAssessmentContentBlank,
  getAssessmentText,
  getCandidateLeaderText,
  getCandidateValuesText,
  updateValuesOverallText,
} from '../shared/report-util';
import { useAuth } from '../../../providers/auth-provider';
import { REPORT_TYPE } from '../../../utils/constants';

const valuesBreaks = {
  breaks: [3, 2],
  scale: 3,
};

function NewHireCoachingValuesFitMisaligned({ candidate, start, max, reportType = REPORT_TYPE.coaching }) {
  const { isSelect } = useAuth();
  const [assessmentText, setAssessmentText] = useState({});

  const displayHeader = useCallback(() => {
    return start === 0;
  }, [start]);

  const displayValues = useCallback(() => {
    if (candidate?.values.misAligned?.length > 0) {
      if (start === 0) {
        return true;
      }

      if (start < candidate?.values.misAligned?.length) {
        return true;
      }
    }

    return false;
  }, [candidate]);

  const displayPage = () => {
    return displayHeader() || displayValues();
  };

  useEffect(() => {
    if (candidate) {
      setAssessmentText(asve(candidate));
    }
  }, [candidate]);

  return (
    <>
      {displayPage() && (
        <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
          {candidate && (
            <>
              <Container className="candidate-profile-assessment-content">
                {displayHeader() ? (
                  <>
                    <Row className="w-50 justify-content-left">
                      <h3 className="pt-4 pb-1">{getCandidateValuesText(isSelect()).toUpperCase()}</h3>
                      <Stack direction="horizontal" gap={4}>
                        {getAssessmentContentPercentile(
                          `Overall ${getCandidateValuesText(isSelect(), true)} Fit`,
                          candidate.percentiles.values
                        )}
                      </Stack>
                    </Row>
                    <Row className="w-100 pb-2">
                      {getAssessmentText(updateValuesOverallText(isSelect(), assessmentText.values))}
                      {start === 0 && candidate?.values.misAligned?.length > 0 && (
                        <div className="pt-4">
                          Below is a list of{` ${getCandidateValuesText(isSelect(), true)} `}the
                          {` ${getCandidateLeaderText(isSelect())} `}indicated were more important than the Organization
                          currently provides (i.e., the{` ${getCandidateValuesText(isSelect(), true)} `}with the
                          greatest misalignment).
                        </div>
                      )}
                      {start === 0 && candidate?.values.misAligned?.length === 0 && (
                        <div className="pt-4">
                          There were no{` ${getCandidateValuesText(isSelect(), true)} `}the
                          {` ${getCandidateLeaderText(isSelect())} `}indicated were more important than the Organization
                          currently provides (i.e., the
                          {` ${getCandidateValuesText(isSelect(), true)} `}with the greatest misalignment).
                        </div>
                      )}
                    </Row>
                  </>
                ) : (
                  <>
                    <Row className="w-50 justify-content-left">
                      <h3 className="pt-4 pb-1">{getCandidateValuesText(isSelect()).toUpperCase()}</h3>
                    </Row>
                    <Row className="w-100 pb-2">
                      <div className="pt-4">
                        Continued below is a list of{` ${getCandidateValuesText(isSelect(), true)} `}the
                        {` ${getCandidateLeaderText(isSelect())} `}indicated were more important than the Organization
                        currently provides (i.e., the{` ${getCandidateValuesText(isSelect(), true)} `}with the greatest
                        misalignment).
                      </div>
                    </Row>
                  </>
                )}
                <Row className="w-100 mx-auto justify-content-center pt-3">
                  {candidate?.values.misAligned.slice(start, max).map((key) => {
                    return (
                      <Stack direction="horizontal" className="subscore-chart" key={key}>
                        <div className="w-25">
                          {getAssessmentContentBlank(
                            candidate.values.titles[key],
                            candidate.values.ratings[key],
                            valuesBreaks,
                            reportType
                          )}
                        </div>
                        <div className="w-75">{getAssessmentText(assessmentText[key])}</div>
                      </Stack>
                    );
                  })}
                </Row>
              </Container>
            </>
          )}
        </Container>
      )}
    </>
  );
}

export default NewHireCoachingValuesFitMisaligned;
